// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610022135/js/" + chunkId + "." + {"44":"e9be2953","225":"bfc455ad","481":"f63865fd","486":"878ec1f7","770":"5482a903"}[chunkId] + ".0.5847598281357025.chunk.js";
};